'use client';

import type { PropsWithChildren } from 'react';
import { useTransition } from 'react';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { CircularProgress } from '@packages/shared/src/ui/CircularProgress/CircularProgress';
import type { VariationSelectionSku, VariationSelectionOnSelectHandler } from '../../types';
import { useVariationFormattedLink } from '../../utils/useVariationFormattedLink';
import { sharedTileButtonClass } from './shared';

export type TileButtonDefaultProps = PropsWithChildren &
  VariationSelectionSku &
  VariationSelectionOnSelectHandler;

/* 
  The TileButton component is a common Button component but is extended with a loading indicator
  which is visible while the new variation is loading data
*/
export const TileButtonDefault = ({ onSelect, sku, children }: TileButtonDefaultProps) => {
  const [isPending, startTransition] = useTransition();
  const { getOnSelectCallback } = useVariationFormattedLink();
  const onClickHandler = getOnSelectCallback({ sku, onSelect });

  return (
    <Button
      size="large"
      className={sharedTileButtonClass}
      onClick={() => startTransition(() => onClickHandler())}
    >
      {/* ! important marker here is needed because otherwise the button styling will overwrite the size of the icon */}
      {isPending && <CircularProgress className="translate-[-50%, -50%] absolute size-2.5!" />}
      <span className={`py-1 ${isPending ? 'opacity-0' : ''}`}>{children}</span>
    </Button>
  );
};
